<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="自动生成标题策略"
      :visible.sync="visible"
      width="900px"
      @close="handleCloseDialog"
      class="amazon_category_dialog"
    >
      <div>
        <div style="height:450px;overflow-y: auto;overflow-x: hidden;">
          <draggable :list="list" @start="drag = true" @end="drag = false">
            <div
              style="position: relative;"
              v-for="(record, index) in list"
              :key="index"
              :name="`${record.name}`"
              class="group"
            >
              <div class="caption">
                <i
                  style="font-weight:bold;margin: 0 8px 0 0;"
                  class="el-icon-sort"
                ></i>

                <span
                  @click="handleEditTitle(record, $event)"
                  style="color:#4934b2;"
                  v-if="!record.isEdit"
                  ><i
                    v-if="record.name != 'title'"
                    class="el-icon-edit mr-5px"
                  ></i
                  >{{
                    record.typeName ? record.typeName : "未命名分组"
                  }}（可拖动）</span
                >
                <div class="range">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`输入随机出现次数的范围`"
                    placement="top"
                    style="margin: 0 8px 0 0;"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>

                  <div class="start el-input el-input--mini">
                    <el-input v-model="record.termMin" size="small"></el-input>
                  </div>
                  <span class="INFO ml-10px mr-10px">-</span>
                  <div class="end el-input el-input--mini">
                    <el-input v-model="record.termMax" size="small"></el-input>
                  </div>
                </div>
                <span v-if="record.isEdit"
                  ><el-input
                    @blur="handleEditTitle(record, $event)"
                    @focus.native="handleInputTitle(record, $event)"
                    v-model="record.typeName"
                    size="small"
                    style="width:200px;"
                    placeholder="未命名分组"
                  ></el-input
                ></span>

                <span
                  v-if="record.name != 'title'"
                  @click="handleRemoveGroup(index)"
                  style="float:right;  position: absolute;right: 8px;"
                >
                  <i
                    style="font-weight:bold;margin: 0 8px 0 0;color:red;  "
                    class="el-icon-close"
                  ></i>
                </span>
              </div>
              <div class="content">
                <div
                  style="padding-left: 16px;"
                  class="text"
                  v-if="record.content"
                >
                  {{ record.content }}
                </div>
                <div v-if="record.name != 'title'" class="terms">
                  <div class="keywords">
                    <div
                      v-if="record.stitleTemplateTypeTerms.length > 0"
                      v-for="(term, i) in record.stitleTemplateTypeTerms"
                      :key="i"
                      class="keyword"
                    >
                      <div class="mr-10px">
                        <div class="PRIMARY c-pointer">
                          {{ term.term }}
                        </div>
                        <div class="INFO mt-5px">
                          {{ term.termCn }}
                        </div>
                      </div>
                      <div
                        @click="
                          handleRemoveTerm(record.stitleTemplateTypeTerms, i)
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </div>
                    </div>
                    <div @click="handleAddTerm(record)" class="add-term-btn">
                      <i class="fa fa-plus"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <div
          @click="handleAddGroup"
          class="add-button"
          style="margin:20px 0 0 0;box-sizing:border-box;padding: 10px 15px;background-color: #f9f9f9;position: relative;cursor: pointer;text-align:center;"
        >
          <i
            class="el-icon-plus"
            style="font-weight:bold;margin: 0 4px 0 0;"
          ></i
          >添加新组
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="float:left;">
          <el-select
            @change="handleChangeTemplate"
            style="margin: 0 16px 0 0;"
            size="small"
            v-model="templateId"
            placeholder="我的模板"
            filterable
            clearable
            ref="templateSelect"
          >
            <el-option
              v-for="(option, index) in templateList"
              :key="index"
              :label="option.templateName"
              :value="option.templateId"
            ></el-option>
          </el-select>
          <el-button
            style="margin: 0 8px 0 0;"
            @click="handleSaveTemplate"
            :disabled="!templateId"
            size="small"
            >保存模板</el-button
          >
          <el-button @click="handleShowTemplateDialog" size="small"
            >模板管理</el-button
          >
        </div>

        <el-button
          style="margin: 0 20px 0 0;"
          type="success"
          @click="handleShowPreviewTerms"
          size="small"
          >预 览</el-button
        >
        <el-button
          style="margin: 0 20px 0 0;"
          @click="handleCloseDialog"
          size="small"
          >关 闭</el-button
        >
        <el-button
          style="margin: 0 8px 0 0;"
          type="primary"
          @click="handleSubmit"
          size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <TermManageDialog
      @update="handleUpdateGroup"
      v-model="termManageVisible"
    ></TermManageDialog>
    <TemplateManageDialog
      @change="getTemplateList"
      v-model="templateManageVisible"
    ></TemplateManageDialog>

    <el-dialog
      :close-on-click-modal="false"
      title="预览"
      :visible.sync="previewVisible"
      width="800px"
    >
      <div class="results">
        <div
          v-for="(record, index) in previewTerms"
          :key="index"
          class="result"
        >
          <div class="index1">{{ index + 1 }}.</div>
          <div>
            <div>
              <div class="text">{{ record.en }}</div>
              <div class="INFO mt-10px" style="position:relative;">
                <i
                  v-if="false"
                  style="position:absolute;left:-14px;top: 4px;"
                  class="el-icon-caret-right"
                ></i>
                {{ record.cn }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" size="small" @click="handlePreviewTerms"
          >重新生成</el-button
        >
        <el-button size="small" @click="previewVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSkuList } from "@/api/template/template"
import { mapGetters } from "vuex"
import { getCategorySuggestion } from "@/api/order/lazada"
import draggable from "vuedraggable"
import TermManageDialog from "./TermManageDialog"
import TemplateManageDialog from "./TemplateManageDialog"
import {
  getTemplateList,
  getTemplate,
  addTemplate,
  previewTerms,
} from "@/api/sysSupport/term"
import moment from "moment"

export default {
  name: "TermDialog",
  components: { draggable, TermManageDialog, TemplateManageDialog },
  data() {
    return {
      tables: [],
      showPriceDialog: false,
      priceModify: "",
      priceType: "",
      isSet: false,
      skuList: [],
      activeNames: [],
      options: [],
      value: [],
      templateList: [],
      termManageVisible: false,
      templateManageVisible: false,
      list: [
        {
          name: "title",
          typeName: "我的核心词",
          termMin: "0",
          termMax: "1",
          content: "这里是我的核心词的位置(标题上保留的原内容)",
          stitleTemplateTypeTerms: [],
          isEdit: false,
        },
      ],
      templateName: "",
      templateOptions: [],
      loading: false,
      categoryPath: "",
      templateId: "",
      previewVisible: false,
      previewTerms: [],
      oldval: "",
    }
  },
  watch: {
    visible: {
      async handler() {
        if (this.visible) {
          this.list = [
            {
              name: "title",
              typeName: "我的核心词",
              termMin: "0",
              termMax: "1",
              content: "这里是我的核心词的位置(标题上保留的原内容)",
              stitleTemplateTypeTerms: [],
              isEdit: false,
            },
          ]
          this.templateId = ""
          this.templateName = ""
          await this.getTemplateList()

          if (this.templateInfo) {
            this.templateId = this.templateInfo
            this.getTemplateInfo()
          }
        }
      },
      immediate: true,
    },
    list: {
      handler() {
        let names = []
        for (let record of this.list) {
          names.push(record.name)
        }
        this.activeNames = names
      },
      immediate: true,
      deep: true,
    },
    templateId(val, oldval) {
      this.oldval = oldval
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    templateInfo: {
      type: String,
      default: "",
    },
    productName: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleAddTerm(row) {
      this.groupName = row.name
      this.termManageVisible = true
    },
    handleRemoveTerm(terms, i) {
      terms.splice(i, 1)
    },
    async getTemplateList() {
      let params = this._.clone({
        pageNum: 1,
        pageSize: 1000,
        templateName: "",
      })
      let response = await getTemplateList(params)
      this.templateList = response.rows
    },
    async handleChangeTemplate() {
      this.$confirm(`切换模板未保存的数据会丢失，确定切换模板吗?`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getTemplateInfo()
          window.setTimeout(() => {
            this.$refs["templateSelect"].blur()
          }, 0)
        })
        .catch(() => {
          this.templateId = this.oldval
          window.setTimeout(() => {
            this.$refs["templateSelect"].blur()
          }, 0)
        })
    },
    async getTemplateInfo() {
      if (this.templateId) {
        let result = await getTemplate(this.templateId)
        this.templateName = result.data.templateName
        for (let record of result.data.sTitleTemplateTypes) {
          record.isEdit = false
          if (record.typeName == "我的核心词") {
            record.name = "title"
            record.content = "这里是我的核心词的位置(标题上保留的原内容)"
          } else {
            record.name = Math.random()
          }
        }
        this.list = result.data.sTitleTemplateTypes
      } else {
        this.list = [
          {
            name: "title",
            typeName: "我的核心词",
            termMin: "0",
            termMax: "1",
            content: "这里是我的核心词的位置(标题上保留的原内容)",
            stitleTemplateTypeTerms: [],
            isEdit: false,
          },
        ]
      }
    },
    async handleSaveTemplate() {
      let sTitleTemplateTypes = JSON.parse(JSON.stringify(this.list))
      for (let record of sTitleTemplateTypes) {
        delete record["content"]
        delete record["name"]
        delete record["isEdit"]
      }
      try {
        let result = await addTemplate({
          templateId: this.templateId,
          templateName: this.templateName,
          sTitleTemplateTypes: sTitleTemplateTypes,
        })
        this.msgSuccess("保存模板成功")
      } catch (error) {}
    },
    handleUpdateGroup(terms) {
      for (let record of this.list) {
        if (record.name == this.groupName) {
          for (let term of terms) {
            let find = false
            for (let item of record.stitleTemplateTypeTerms) {
              if (item.term == term.term) {
                find = true
                break
              }
            }
            if (!find) {
              record.stitleTemplateTypeTerms.push({
                term: term.term,
                termCn: term.termCn,
              })
            }
          }
        }
      }
    },
    handleShowPreviewTerms() {
      this.handlePreviewTerms()
      this.previewVisible = true
    },
    handleShowTemplateDialog() {
      this.templateManageVisible = true
    },
    onMove(e) {
      if (!e.relatedContext.element) {
        return false
      }
      if (e.relatedContext.element.isMain) {
        return false
      }
      return true
    },
    handleEditTitle(record, event) {
      if (record.name == "title") {
        return
      }
      record.isEdit = !record.isEdit
      event.stopPropagation()
    },
    handleInputTitle(record, event) {
      event.stopPropagation()
    },
    handleAddGroup() {
      this.list.push({
        name: Math.random().toString(),
        typeName: "",
        content: "",
        stitleTemplateTypeTerms: [],
        isEdit: false,
        termMin: "0",
        termMax: "1",
      })
    },
    async handlePreviewTerms() {
      this.startLoading()
      await this.processData()
      let result = await previewTerms({
        templateId: this.templateId,
        num: 5,
        keyName: this.productName,
      })
      this.previewTerms = result.data
      this.endLoading()
    },
    async processData() {
      let sTitleTemplateTypes = JSON.parse(JSON.stringify(this.list))
      for (let record of sTitleTemplateTypes) {
        delete record["content"]
        delete record["name"]
        delete record["isEdit"]
      }
      //判断有没有templateId，如果有直接保存，如果没有生成临时的
      if (this.templateId) {
        try {
          let result = await addTemplate({
            templateId: this.templateId,
            templateName: this.templateName,
            sTitleTemplateTypes: sTitleTemplateTypes,
          })
        } catch (error) {}
      } else {
        let result = await addTemplate({
          templateName: "模板" + moment(new Date()).format("yyyyMMDDHHmmss"),
          sTitleTemplateTypes: sTitleTemplateTypes,
        })
        this.templateId = result.msg
      }
      this.getTemplateList()
    },
    async handleSubmit() {
      await this.processData()
      this.$emit("change", false)
      this.$emit("update", this.templateId)
    },
    handleClose() {
      this.$emit("change", false)
      this.$emit("update", "")
    },
    handleCloseDialog() {
      this.$emit("change", false)
    },
    handleRemoveGroup(index) {
      this.list.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 119px;
}
.avator {
}
.info {
  margin-left: 4px;
}
.amazon_category_dialog ::v-deep .el-dialog__footer {
  text-align: right;
}

.amazon_category_dialog ::v-deep .el-collapse-item__header {
  padding: 0px 8px;
  background-color: #f9f9f9;
}

.amazon_category_dialog ::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}

.text {
  text-align: left;
  margin: 24px 10px 24px 0;
  color: #909399;
}
.terms {
  margin: 0px 0 0 16px;
}
.add-button:hover {
  color: #4934b2;
}
.add-term-btn {
  border: 1px solid #ebeef5;
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.fa-plus {
  line-height: 31px;
  color: #4934b2;
}
.keywords {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
}
.keyword {
  margin-right: 10px;
  border: 1px solid #ebeef5;
  padding: 7px 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  line-height: 16px;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}
.mr-10px {
  margin-right: 10px;
}
.INFO {
  color: #909399;
}
.mt-5px {
  margin-top: 5px;
}
.c-pointer {
  cursor: pointer;
}
.PRIMARY {
  color: #4934b2 !important;
}
.keyword .fa-remove {
  cursor: pointer;
  color: #4934b2;
}
.terms {
  margin: 16px 16px 6px 16px;
}
.range {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
  top: 5px;
  right: 50px;
}
.range .el-input {
  width: 50px;
}
.ml-10px {
  margin-left: 10px;
}
.group .caption {
  padding: 10px 15px;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}
.group {
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  background-color: #fff;
  width: 99%;
}
.results {
  min-height: 300px;
}
.results .result {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  padding: 8px 10px 11px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.results .result .index1 {
  font-size: 28px;
  margin-right: 10px;
  margin-top: 5px;
}
.results .result .text {
  line-height: 22px;
  padding-bottom: 8px;
  margin: 4px 0 0 0;
  color: #606266;
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
}
.INFO {
  color: #909399;
}
.mt-10px {
  margin-top: 10px;
}
.results .result .svg-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
</style>
